import { useState } from "react";
import { Form, Card, Button } from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import { LuLogOut } from "react-icons/lu";
import { twoFactorAuthServices } from "../../APIServices/UserData/twoFactorAuthServices";
import { authServices } from "../../APIServices/UserData/authServices";

export default function TwoFactorAuth({ currentUserData }) {
  const [otp, setOTP] = useState(["", "", "", "", "", ""]);
  const [loader, setLoader] = useState(false);

  function getTwoInitials(name) {
    if (!name) return "";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  const twpFactorAuthenticationVerify = async () => {
    if (otp.some(d => !d)) return;

    setLoader(true);
    const endPoint =
      currentUserData?.authType === "apps"
        ? twoFactorAuthServices.verifyTwoFAForAppLogin
        : twoFactorAuthServices.verifyTwoFAForEmailLogin;

    const data = await endPoint({ otp: otp.join("") });
    setLoader(false);

    if (data?.statusCode === 200) {
      setOTP(["", "", "", "", "", ""]);
      window.location.reload();
    }
  };

  const logout = async () => {
    await authServices.logout();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);

    if (pasted.length === 6) {
      const newOtp = pasted.split("");
      setOTP(newOtp);
      document.getElementById("otp-5")?.focus();
    }
  };

  return (
    <div className="hstack justify-content-center" style={{ height: "100vh" }}>
      <Card className="border-0 shadow" style={{ borderRadius: 18, width: 420 }}>
        <Card.Body className="p-4">
          <div className="text-center mb-4">
            <h4 className="fw-bold mb-1">Two Factor Authentication</h4>
            <small className="text-muted">
              Enter the 6-digit code{" "}
              {currentUserData?.appTwoFA && "from app"}
              {currentUserData?.emailTwoFA && " sent to email"}
            </small>
          </div>

          <div className="hstack gap-2 mb-3">
            <h6 className="bg-primary-subtle p-3 rounded-1 fw-bold m-0">
              {getTwoInitials(currentUserData?.name)}
            </h6>
            <div>
              <h6 className="m-0">{currentUserData?.name}</h6>
              <p className="small m-0 text-muted">{currentUserData?.email}</p>
            </div>
          </div>

          <Form.Group className="mb-4 text-center">
            <Form.Label className="mb-2">Verification Code</Form.Label>
            <div className="d-flex justify-content-center gap-2">
              {otp.map((digit, index) => (
                <Form.Control
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  className="text-center interactive-input fw-bold"
                  style={{
                    width: 48,
                    height: 52,
                    fontSize: "1.25rem",
                    borderRadius: 10,
                  }}
                  onPaste={handlePaste}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/, "");
                    if (!value) return;

                    const newOtp = [...otp];
                    newOtp[index] = value;
                    setOTP(newOtp);

                    if (index < 5) {
                      document.getElementById(`otp-${index + 1}`)?.focus();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace") {
                      const newOtp = [...otp];
                      newOtp[index] = "";
                      setOTP(newOtp);

                      if (index > 0) {
                        document.getElementById(`otp-${index - 1}`)?.focus();
                      }
                    }
                  }}
                />
              ))}
            </div>
          </Form.Group>

          <Button
            onClick={twpFactorAuthenticationVerify}
            disabled={loader || otp.some(d => !d)}
            className="w-100 py-2 fw-bold btn-gradient"
          >
            Verify & Continue <FaArrowRight />
          </Button>

          <div className="text-center mt-2" style={{ fontSize: 14 }}>
            <span onClick={logout} className="CP fw-semibold text-danger">
              <LuLogOut /> Sign Out
            </span>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
